import {
    HttpRequest,
    HttpHandlerFn,
    HttpEvent,
    HttpInterceptorFn,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { AuthService } from '../services/auth';
import { environment } from 'src/environments/environment';

export const authInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const router = inject(Router);
    const alertController = inject(AlertController);
    const authService = inject(AuthService);

    // If request is for our API base URL, inject default headers (do not override existing ones)
    let req: HttpRequest<unknown> = request;
    if (request.url.startsWith(environment.baseUrl)) {
        const headersToSet: Record<string, string> = {};
        headersToSet['X-CD'] = environment.XCD;
        headersToSet['X-UT'] = environment.XUT;
        headersToSet['X-Version'] = environment.version;
        req = request.clone({ setHeaders: headersToSet });
    }

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
                if (!request.url.includes('/auth')) {
                    return from(authService.initAuth()).pipe(
                        switchMap(() => from(router.navigate(['/auth/init']))),
                        switchMap(() => throwError(() => error))
                    );
                }
            }
            return throwError(() => error);
        })
    );
};
